import { render, staticRenderFns } from "./WorkflowCreateRisk.vue?vue&type=template&id=2a59ab58&"
import script from "./WorkflowCreateRisk.vue?vue&type=script&lang=js&"
export * from "./WorkflowCreateRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports